import React from 'react';
import { Tag } from 'antd';
import { display } from 'constants/types';

const AccountPartnerType = ({ type }) => {
  return <Tag>{display[type]}</Tag>;
};

export default AccountPartnerType;
